import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../stores/useAuthStore";
import { queryKeys } from "../api/queryKeys";
import api from "../api/client";

/**
 * Composite hook for authentication logic.
 *
 * Combines Zustand state (token) with side effects like logout
 * (which needs to clear both the token AND the query cache).
 */
export const useAuth = () => {
  const { token, setToken: setStoreToken, clearToken: clearStoreToken } = useAuthStore();
  const queryClient = useQueryClient();

  const logout = useCallback(async () => {
    try {
      await api.post("/logout", {});
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Always clear local state even if server logout fails
      clearStoreToken();
      queryClient.removeQueries({ queryKey: queryKeys.user.me });
    }
  }, [clearStoreToken, queryClient]);

  return {
    token,
    isAuthenticated: !!token,
    setToken: setStoreToken,
    logout,
  };
};
